import {buildChoiceQuestionPrintView} from '@/common/questionPrintView/multipleChoice'
import {buildDefaultQuestionPrintView} from '@/common/questionPrintView/default'
import {buildDrawingQuestionPrintView} from '@/common/questionPrintView/drawing'
import {buildFillInTheBlankQuestionPrintView} from '@/common/questionPrintView/fillInTheBlank'
import {buildGroupingQuestionPrintView} from '@/common/questionPrintView/grouping'
import {buildHotSpotQuestionPrintView} from '@/common/questionPrintView/hotSpot'
import {buildHotTextQuestionPrintView} from '@/common/questionPrintView/hotText'
import {buildLabelingQuestionPrintView} from '@/common/questionPrintView/labeling'
import {buildMatchingQuestionPrintView} from '@/common/questionPrintView/matching'
import {buildMediaBlockQuestionPrintView} from '@/common/questionPrintView/mediaBlock'
import {buildNumericResponseQuestionPrintView} from '@/common/questionPrintView/numericResponse'
import {buildOpenResponseQuestionPrintView} from '@/common/questionPrintView/openResponse'
import {buildSelectAllThatApplyQuestionPrintView} from '@/common/questionPrintView/selectAllThatApply'
import {buildSortingQuestionPrintView} from '@/common/questionPrintView/sorting'
import {buildTrueFalseQuestionPrintView} from '@/common/questionPrintView/trueFalse'

const buildQuestionPrintView = (question) => {
    if (!question) {
        return ''
    }

    const content = question.content ? question.content : {}

    switch (question.type) {
            // these types only have relevant data in the question field
        case 'text_block':
            return buildDefaultQuestionPrintView(content)

            // these types are all variations on multiple choice
        case 'multiple_choice':
        case 'new_multiple_choice':
            return buildChoiceQuestionPrintView(content)

            // these types are all variations on select all that apply
        case 'new_select_all_that_apply':
            return buildSelectAllThatApplyQuestionPrintView(content)

            // these types are all variations on fill in the blank
        case 'fill_in_the_blank':
            return buildFillInTheBlankQuestionPrintView(content)

        case 'matching':
            return buildMatchingQuestionPrintView(content)
        case 'labeling':
            return buildLabelingQuestionPrintView(content)
        case 'drawing':
            return buildDrawingQuestionPrintView(content)
        case 'open_response':
            return buildOpenResponseQuestionPrintView(content)
        case 'sorting':
            return buildSortingQuestionPrintView(content)
        case 'true_false':
            return buildTrueFalseQuestionPrintView(content)
        case 'numeric_response':
            return buildNumericResponseQuestionPrintView(content)
        case 'grouping':
            return buildGroupingQuestionPrintView(content)
        case 'hot_spot':
            return buildHotSpotQuestionPrintView(content)
        case 'hot_text':
            return buildHotTextQuestionPrintView(content)
        case 'media_block':
            return buildMediaBlockQuestionPrintView(content)
        default:
            return buildDefaultQuestionPrintView(content)
    }
}

export {buildQuestionPrintView}
